import React, { Component } from 'react';
import Cookies from 'js-cookie';
import '../../css/MenuUsuario.css';

export default class MenuUsuario extends Component {
  constructor(props) {
    super(props);

    this.state = {
      menuUsuarioAbierto: false,
      autenticado: false, // Agregar estado de autenticación
    };

    this.toggleMenuUsuario = this.toggleMenuUsuario.bind(this);
    this.cerrarMenuUsuario = this.cerrarMenuUsuario.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);
    this.handleStorageChange = this.handleStorageChange.bind(this);
    this.checkAuthentication = this.checkAuthentication.bind(this);
  }

  componentDidMount() {
    // Agregar event listener para cerrar menú al hacer click fuera
    document.addEventListener('mousedown', this.handleClickOutside);

    // Agregar event listener para cambios en localStorage (sincronización entre pestañas)
    window.addEventListener('storage', this.handleStorageChange);

    // Verificar autenticación inicial
    this.checkAuthentication();

    // Verificar autenticación periódicamente
    this.authCheckInterval = setInterval(this.checkAuthentication, 1000);
  }

  componentWillUnmount() {
    // Limpiar event listeners
    document.removeEventListener('mousedown', this.handleClickOutside);
    window.removeEventListener('storage', this.handleStorageChange);

    // Limpiar intervalo
    if (this.authCheckInterval) {
      clearInterval(this.authCheckInterval);
    }
  }

  // Método para detectar clicks fuera del menú
  handleClickOutside(event) {
    if (this.menuRef && !this.menuRef.contains(event.target)) {
      this.setState({ menuUsuarioAbierto: false });
    }
  }

  // Método para verificar el estado de autenticación
  checkAuthentication() {
    // Verificar flags de logout forzado primero
    const forceLogout = localStorage.getItem('force_logout');
    const logoutEvent = localStorage.getItem('logout_event');

    if (forceLogout === 'true' || logoutEvent) {
      const logoutTime = logoutEvent ? parseInt(logoutEvent) : 0;
      const now = Date.now();
      // Si el logout es reciente (menos de 30 segundos), mantener desautenticado
      if (now - logoutTime < 30000) {
        if (this.state.autenticado !== false) {
          this.setState({ autenticado: false });
          window.location.href = "/inicio";
        }
        return;
      }
    }

    const autenticado = !!Cookies.get("token") || !!sessionStorage.getItem("access_token");
    if (this.state.autenticado !== autenticado) {
      this.setState({ autenticado });

      // Si no está autenticado y estamos en una ruta protegida, redirigir
      if (!autenticado && window.location.pathname !== '/inicio' && window.location.pathname !== '/') {
        window.location.href = "/inicio";
      }
    }
  }

  // Método para manejar cambios en localStorage/sessionStorage desde otras pestañas
  handleStorageChange(event) {
    // Si se elimina el access_token o cualquier cookie importante, o hay logout forzado
    if (event.key === 'logout_event' ||
      event.key === 'force_logout' ||
      event.key === null || // localStorage.clear() fue llamado
      (event.key === 'access_token' && !event.newValue)) {

      // Verificar flags de logout forzado
      const forceLogout = localStorage.getItem('force_logout');
      const logoutEvent = localStorage.getItem('logout_event');

      if (forceLogout === 'true' || logoutEvent) {
        // Limpiar inmediatamente toda la sesión en esta pestaña
        this.limpiarCookies();
        this.limpiarSessionStorage();
        this.setState({ autenticado: false });
        window.location.href = "/inicio";
        return;
      }

      // Verificar si realmente no hay autenticación
      const tieneToken = !!Cookies.get("token") || !!sessionStorage.getItem("access_token");

      if (!tieneToken) {
        // Cerrar sesión en esta pestaña también
        this.setState({ autenticado: false });
        window.location.href = "/inicio";
      }
    }
  }

  // Métodos para controlar el menú desplegable
  toggleMenuUsuario() {
    this.setState({ menuUsuarioAbierto: !this.state.menuUsuarioAbierto });
  }

  cerrarMenuUsuario() {
    this.setState({ menuUsuarioAbierto: false });
  }

  limpiarCookies() {
    Cookies.remove("nombres");
    Cookies.remove("apellidos");
    Cookies.remove("identificacion");
    Cookies.remove("token");
    Cookies.remove("rol");
    Cookies.remove("username");
    Cookies.remove("DatosPersonalesGIA.CAS");
    Cookies.remove("id");
    Cookies.remove("correoAlterno");
    Cookies.remove("Nombre");
  }

  limpiarSessionStorage() {
    // Limpiar sessionStorage que también se usa para autenticación
    sessionStorage.removeItem("access_token");
    sessionStorage.removeItem("user_data");
    sessionStorage.removeItem("nombres");
    sessionStorage.removeItem("apellidos");
    sessionStorage.removeItem("entra_login_done"); // Importante: limpiar flag de login de Azure AD
    // Limpiar cualquier otra data de sesión que pueda existir
    sessionStorage.clear();
  }

  handleCerrarSesion = () => {
    // Notificar a otras pestañas que se está cerrando sesión con timestamp más duradero
    const logoutTime = Date.now();
    localStorage.setItem('logout_event', logoutTime.toString());
    localStorage.setItem('force_logout', 'true'); // Flag adicional más persistente

    // Limpiar toda la información de sesión local
    this.limpiarCookies();
    this.limpiarSessionStorage();

    // Limpiar los eventos después de 30 segundos (más tiempo para sincronización)
    setTimeout(() => {
      localStorage.removeItem('logout_event');
      localStorage.removeItem('force_logout');
    }, 30000);

    // Redirigir al endpoint de logout que maneja correctamente Azure AD
    window.location.href = "/logout";
  }

  render() {
    // Usar el estado interno de autenticación que se actualiza automáticamente
    const { autenticado } = this.state;

    // Si no está autenticado, no mostrar nada
    if (!autenticado) {
      return null;
    }

    // Usar props para mostrar nombre si se proporciona
    const { mostrarNombre, nombresCompletos } = this.props;

    return (
      <div
        className="menu-usuario-container"
        style={{
          position: "absolute",
          top: 16,
          right: 32,
          zIndex: 1000,
          display: "flex",
          alignItems: "center",
          gap: "12px"
        }}
        ref={(ref) => this.menuRef = ref}
      >
        {/* Mostrar nombre del usuario si se proporciona */}
        {mostrarNombre && nombresCompletos && (
          <span className="nombres-usuario-texto"
          style={{
            color: "#ffd700",
            fontWeight: "500",
            fontSize: "14px"
          }}>
            {nombresCompletos}
          </span>
        )}

        {/* Contenedor del botón con posición relativa para el dropdown */}
        <div style={{ position: "relative" }}>
          {/* Botón principal del menú con icono de usuario y flecha */}
          <button
            className="btn-menu-usuario"
            onClick={this.toggleMenuUsuario}
          >
            {/* Icono de usuario */}
            <span className="icono-usuario">
              👤
            </span>

            {/* Flecha */}
            <span className={`flecha ${this.state.menuUsuarioAbierto ? 'abierto' : ''}`}>
              ▼
            </span>
          </button>

          {/* Menú desplegable */}
          {this.state.menuUsuarioAbierto && (
            <div className="menu-usuario-desplegable">
              <button
                className="btn-cerrar-sesion"
                onClick={() => {
                  this.cerrarMenuUsuario();
                  this.handleCerrarSesion();
                }}
              >
                <span>🚪</span>
                <span>Cerrar sesión</span>
              </button>
            </div>
          )}
        </div>
      </div>
    );
  }
}
